import { FC } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import clsx from 'clsx';

interface Props extends VariantProps<typeof cvaRoot> {
  className?: string;
}

const cvaWrapper = cva([
  'Skeleton-cvaWrapper',
  'relative overflow-hidden',
  'after:w-full after:h-full after:absolute after:animate-voting after:top-0 after:left-0 after:bg-skeleton',
]);
const cvaRoot = cva(['Skeleton-cvaRoot', 'overflow-hidden w-full h-full'], {
  variants: {
    rounded: {
      circle: 'rounded-[50%] ',
    },
    intent: {
      fill: 'bg-cBlurred',
      outline:
        'border-4 border-cBlurred rounded-[2.4rem] md-max:rounded-[1.6rem]',
      none: '',
    },
  },
  defaultVariants: {
    intent: 'fill',
  },
});

const Skeleton: FC<Props> = ({ className, intent, rounded }) => {
  return (
    <div className={clsx(cvaWrapper(), className)}>
      <div className={clsx(cvaRoot({ intent, rounded }))}></div>
    </div>
  );
};

export default Skeleton;
